import * as React from 'react'
import { bindActionCreators, Dispatch } from 'redux'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { connect } from 'react-redux'
import * as actionCreators from "../../action-creators"
import { ReducerState, MappedActionsProps } from "../../reducer"
import ObservationTableComponent from "./observation-table-component"
import { getProfile, Profile } from '../../domain/sfp/user-domain'
import { LocalAuthority, Observation, Account, Chapter } from '../../model'
import { createObservation, deleteObservation, updateObservation } from '../../service/sfp/observations-service-2'
import { Instance } from 'react-table'
import { find } from 'lodash'

class ObservationTable extends React.Component<InjectedProps, State> {
	public reactTableData: Instance<any>

	constructor(props: Readonly<InjectedProps>) {
		super(props)
		this.state = {
			data: [],
			focusedCell: null,
			loading: props.loading,
			displayAddAccount: false,
			classes: [],
			loadingChapters: false,
			showExport: false,
			sortedData: null,
			submitting: false,
			selectedFile: null,
			showPopUp: false,
			selectedYear: null,
			checked: false
		}
	}

	componentDidMount() {
		const store = localStorage.getItem("isupdateCellData")
		if (store === "true") {
			localStorage.setItem("isupdateCellData", "false")
			this.props.currentLocalAuthority && this.props.actions.fetchCurrentLocalAuthorityIfNeeded(this.props.currentLocalAuthority.id)
		}
		if (!this.props.years) return
		this.setData(this.props)
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.operation != nextProps.operation) {
			const store = localStorage.getItem("isupdateCellData")
			if (store === "true") {
				localStorage.setItem("isupdateCellData", "false")
				this.props.currentLocalAuthority && this.props.actions.fetchCurrentLocalAuthorityIfNeeded(this.props.currentLocalAuthority.id)
			}
		}
		if (!nextProps.years) return
		this.setData(nextProps)
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.loadingCurrentLocalAuthority && this.props.loadingCurrentLocalAuthority != prevProps.loadingCurrentLocalAuthority) {
			this.setState({ loading: true })
		}
		if (prevProps.loadingCurrentLocalAuthority && this.props.loadingCurrentLocalAuthority != prevProps.loadingCurrentLocalAuthority) {
			this.setState({ loading: false })
		}
		if (prevProps.loadingUploadFile !== this.props.loadingUploadFile) {
			this.setState({ showPopUp: this.props.loadingUploadFile })
		}
	}
	handleChange = (checked: boolean) => {
		this.setState({ checked });
	}
	render() {
		var consulted = getProfile(this.props.currentUser) === Profile.LocalAuthorityConsultant
		return (
			<ObservationTableComponent
				consulted={consulted}
				data={this.state.data}
				focusedCell={this.state.focusedCell}
				loading={this.state.loading}
				checked={this.state.checked}
				handleChange={this.handleChange}
				onCellPressDown={(acc: Account, i: number, col: number, obs: Observation, viewIndex: number, year: number, amount: number, oldAmount: number, e: React.SyntheticEvent<Element>) => this.saveObservationAndFocus(acc, i, col, obs, viewIndex, year, amount, oldAmount, e)}
				onCellPressEnter={(acc: Account, i: number, col: number, obs: Observation, viewIndex: number, year: number, amount: number, oldAmount: number, e: React.SyntheticEvent<Element>) => this.saveObservationAndFocus(acc, i, col, obs, viewIndex, year, amount, oldAmount, e)}
				onCellPressUp={(acc: Account, i: number, col: number, obs: Observation, viewIndex: number, year: number, amount: number, oldAmount: number, e: React.SyntheticEvent<Element>) => this.saveObservationAndFocus(acc, i, col, obs, viewIndex, year, amount, oldAmount, e)}
				onCellPressLeft={(acc: Account, i: number, col: number, obs: Observation, viewIndex: number, year: number, amount: number, oldAmount: number, e: React.SyntheticEvent<Element>) => this.saveObservationAndFocus(acc, i, col, obs, viewIndex, year, amount, oldAmount, e)}
				onCellPressRight={(acc: Account, i: number, col: number, obs: Observation, viewIndex: number, year: number, amount: number, oldAmount: number, e: React.SyntheticEvent<Element>) => this.saveObservationAndFocus(acc, i, col, obs, viewIndex, year, amount, oldAmount, e)}
				onCellPressEscape={(i, col, obs, e) => this.handleCellPressEscape(i, col, obs, e)}
				onCellPressShiftTab={(acc: Account, i: number, col: number, obs: Observation, viewIndex: number, year: number, amount: number, oldAmount: number, e: React.SyntheticEvent<Element>) => this.saveObservationAndFocus(acc, i, col, obs, viewIndex, year, amount, oldAmount, e)}
				onCellPressTab={(acc: Account, i: number, col: number, obs: Observation, viewIndex: number, year: number, amount: number, oldAmount: number, e: React.SyntheticEvent<Element>) => this.saveObservationAndFocus(acc, i, col, obs, viewIndex, year, amount, oldAmount, e)}
				onClickCloseButton={e => this.handleCloseModal(e)}
				onClickShowExport={e => this.handleShowExport(e)}
				years={this.props.years}
				localAuthority={this.props.currentLocalAuthority}
				currentUser={this.props.currentUser}
				operation={this.props.operation}
				receipts={this.props.receipts}
				showExport={this.state.showExport}
				handleFile={e => this.onFileChange(e)}
				showPopUp={this.state.showPopUp}
				onCheck={e => this.onCheckYear(e)}
				showPop={r => this.setState({ showPopUp: r == 'true' ? true : false })}
				selectedYear={this.state.selectedYear}
				uploadFile={() => this.onUploadFile()}
				error={this.props.error}
			/>
		)
	}

	private onUploadFile() {
		const formData = this.state.selectedFile
		this.props.actions.uploadFileXml(this.props.currentLocalAuthority.id, formData)
	}

	private onCheckYear(e) {
		this.setState({ selectedYear: e.target.value })
	}

	private onFileChange = event => {
		this.setState({ selectedFile: event.target.files[0] })
	};

	private createObservation(observation: Observation, index: number, column: number,
		oldAmount: number) {
		createObservation(this.props.currentLocalAuthority, observation)
			.then(
				this.updateCell.bind(this, index, column),
				// this.rejectSaveObservation.bind(this, observation, index, column, oldAmount)
			)
	}

	private deleteObservation(observation: Observation, index: number, column: number,
		oldAmount: number) {
		deleteObservation(this.props.currentLocalAuthority, observation)
			.then(
				this.removeCellContent.bind(this, index, column),
				// this.rejectSaveObservation.bind(this, observation, index, column, oldAmount)
			)
	}

	private handleCellPressEscape(index: number, column: number, observation: Observation,
		event: React.SyntheticEvent<Element>) {
		event.preventDefault()
		const data = this.state.data
		data[index][column] = observation
		data[index][column]['loading'] = false
		this.setState({ data, focusedCell: null })
	}

	private handleCloseModal(event: React.SyntheticEvent<Element>) {
		event.preventDefault()
		this.setState({ showExport: false })
	}

	private handleShowExport(event: React.SyntheticEvent<Element>) {
		event.preventDefault()
		this.setState({ showExport: true })
	}

	private getData(operation: boolean, receipts: boolean, localAuthority: LocalAuthority,
		years: number[]) {

		let accountsToDisplay = []

		if (localAuthority) {
			accountsToDisplay = localAuthority.accounts
				.filter(localAuthorityChapterAccount => (
					localAuthorityChapterAccount.account.operation === operation
					&& (receipts? localAuthorityChapterAccount.account.receipts === true : localAuthorityChapterAccount.account.expense === true)
				))
		}

		const data = accountsToDisplay.map(arranged => {
			const row = { ...arranged }
			years.forEach(y => {
				const observation = find(localAuthority.observations, o => (
					o.receipts === receipts
					&& o.account.id === arranged.account.id
					&& o.year === y
				))
				row[y] = observation
			})
			return row
		})
		data.map((item) => {
			years.forEach(y => {
				if (item[y] != undefined || item[y] != null) {
					if (item[y] && item[y].loading == true) {
						item[y].loading = false
						return item[y]
					}
				}
			})

		})
		return data
	}

	private rejectSaveObservation(observation: Observation, index: number, column: number,
		oldAmount: number, error: Error) {
		observation.amount = oldAmount
		this.updateCell(index, column, observation)
		this.props.actions.throwError(error)
	}

	private removeCellContent(index: number, column: number) {
		const data = this.state.data
		delete data[index][column]
		this.setState({ data })
	}

	private saveObservation(account: Account, index: number, column: number,
		observation: Observation, amount: number, oldAmount: number) {
		if ((observation && observation.amount == amount)
			|| (!observation && 0 == amount)) return

		const data = this.state.data
		data[index][column] = data[index][column] || {}
		data[index][column]['loading'] = true
		data[index][column]['amount'] = amount

		this.setState({ data })

		let newObservation

		if (observation) {
			if (amount) {
				observation.amount = amount
				this.updateObservation(observation, index, column, oldAmount)
			} else {
				observation.amount = 0
				this.deleteObservation(observation, index, column, oldAmount)
			}
		} else {
			newObservation = {
				id: undefined,
				localAuthority: this.props.currentLocalAuthority,
				account,
				amount: parseFloat(amount.toString()),
				receipts: this.props.receipts,
				year: parseInt(column.toString())
			}
			this.createObservation(newObservation, index, column, oldAmount)
		}
	}

	private saveObservationAndFocus(account: Account, index: number, column: number,
		observation: Observation, viewIndex: number, year: number, amount: number,
		oldAmount: number, event: React.SyntheticEvent<Element>): void {
		event.preventDefault()
		this.setState({ focusedCell: { viewIndex, year } })
		this.saveObservation(account, index, column, observation, amount, oldAmount)
	}

	private setData(props: ObservationTableProps) {
		const data = props ?
			this.getData(
				this.props.operation,
				this.props.receipts,
				this.props.currentLocalAuthority,
				this.props.years
			) : []

		this.setState({ data, loading: props.loading })
	}

	private updateObservation(observation: Observation, index: number, column: number,
		oldAmount: number) {
		updateObservation(this.props.currentLocalAuthority, observation)
			.then(
				this.updateCell.bind(this, index, column),
				// this.rejectSaveObservation.bind(this, observation, index, column, oldAmount)
			)
	}

	private updateCell(index: number, column: number, observation: Observation) {
		const data = this.state.data
		data[index][column] = observation
		localStorage.setItem("isupdateCellData", "true")
		if (observation)
			data[index][column]['loading'] = false
		this.setState({ data })
	}
}


const mapStateToProps = (state: ReducerState) => state
function mapDispatchToProps(dispatch: Dispatch<ReducerState>): MappedActionsProps {
	return { actions: bindActionCreators(actionCreators, dispatch) }
}

// export default connect(mapStateToProps, mapDispatchToProps)(ObservationTable)
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ObservationTable))

interface ObservationTableProps {
	loading: boolean
	operation: boolean
	receipts: boolean
	years: number[]
}

interface State {
	data: any[]
	focusedCell: FocusedCell
	loading: boolean
	displayAddAccount: boolean
	classes: any[]
	loadingChapters: boolean
	showExport: boolean
	sortedData: any[]
	submitting: boolean
	selectedFile: any,
	showPopUp: boolean
	selectedYear: any
	checked: boolean
}

interface FocusedCell {
	viewIndex: number
	year: number
}

type Row = VariableYears & {
	account: Account
	chapter: Chapter
}

interface VariableYears {
	[year: string]: number
}

type InjectedProps = MappedActionsProps &
	ObservationTableProps &
	ReducerState &
	RouteComponentProps


// WEBPACK FOOTER //
// ./src/component/observation-table/index.tsx